import React, { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import {
  getClientId,
  Simulator_Query,
  Aircraft_Query,
  Ground_Query,
} from "./CrewQueries/BlankStudymatQuery";
import firebase from "../../../Firebase/firebase";
import { Select } from "antd";
import SimulatorForm from "./simulatorForms";
import AircraftForms from "./aircraftForm";
import GroundForms from "./groundForm";
import "../../../assets/styles/custom/components/dashboard/Crew.scss";

const BlankTrainingForms = () => {
  const [search, setsearch] = useState("");
  const [isEdit, setisEdit] = useState(false);
  const [fleetss, setFleetss] = useState("");
  const [isView, setisView] = useState(false);
  const [users, setusers] = useState({});
  const catagoryy = [
    { catagory: "Ground" },
    { catagory: "Simulator" },
    { catagory: "Aircraft" },
  ];
  const [catagories, setCatagories] = useState("");
  useEffect(() => {
    firebase.auth().onAuthStateChanged(async (user) => {
      if (user) {
        const token = await user.getIdToken();
        const idTokenResult = await user.getIdTokenResult();
        setusers({
          user: user,
          token: idTokenResult,
          jwt: token,
        });
      } else console.log("SIGNED OUT");
    });
  }, []);
  const { data: getclient } = useQuery(getClientId, {
    variables: { id: users?.token?.claims?.user_id },
  });
  const { data: simulatorQuery } = useQuery(Simulator_Query, {
    variables: {
      fleet: getclient?.aatmsv4_users[0]?.fleetid,
      id: getclient?.aatmsv4_users[0]?.client.clientsid,
    },
  });
  const { data: aircraftQuery } = useQuery(Aircraft_Query, {
    variables: {
      fleet: getclient?.aatmsv4_users[0]?.fleetid,
      id: getclient?.aatmsv4_users[0]?.client.clientsid,
    },
  });
  const { data: groundQuery } = useQuery(Ground_Query, {
    variables: {
      fleet: fleetss,
      id: getclient?.aatmsv4_users[0]?.client.clientsid,
    },
  });
  // const closeForm = () => {
  //   setisEdit(false)
  //   setisView(false)
  // };
  const Option = Select.Option;
  return (
    <div className="animate__animated animate__fadeIn">
      <div className={isEdit || isView ? "hide-element" : ""}>
        <div className="category-title">
          {catagories === "" ? "Forms" : null}
          {catagories === "Simulator" ? "Simulator Forms" : null}
          {catagories === "Aircraft" ? "Aircraft Forms " : null}
          {catagories === "Ground" ? "Ground Forms " : null}
        </div>
        <div className="table-body-container">
          <div className="table-body-header">
            {catagories === "" ? "All Forms" : null}
            {catagories === "Simulator"
              ? "Click on Form to view the training form & Click on Study to view the study material recommended for this training."
              : null}
            {catagories === "Aircraft" ? "All Forms Aircraft" : null}
            {catagories === "Ground" ? "All Forms Ground" : null}
          </div>
          <div className="client-list-divider"></div>
          <div className="table-container">
            {/* <div className="table-header-container"> */}
            <div className="crew-header">
              <div className="display-record">
                <Select
                  value={catagories ? catagories : "Select your Catagory"}
                  onChange={(e) => setCatagories(e)}
                >
                  {catagoryy?.map((el, i) => (
                    <Option key={i} value={el?.catagory}>
                      {el?.catagory}
                    </Option>
                  ))}
                </Select>
              </div>
              <div>
                <span>Search</span>
                <input
                  type="text"
                  className="crew-search"
                  value={search}
                  onChange={(e) => setsearch(e.target.value)}
                />
              </div>
            </div>
            {catagories === "Simulator" ? (
              <SimulatorForm
                catagories={catagories}
                simulatorQuery={simulatorQuery}
                search={search}
              />
            ) : null}
            {catagories === "Aircraft" ? (
              <AircraftForms
                catagories={catagories}
                aircraft={aircraftQuery}
                search={search}
              />
            ) : null}
            {catagories === "Ground" ? (
              <GroundForms
                catagories={catagories}
                ground={groundQuery}
                search={search}
              />
            ) : null}
          </div>
        </div>
        {/* <div className="print-email-container">
          <button className="print-button">
            <i className="fa fa-print" />
            Print
          </button>
          <button className="email-button">
            <i className="fa fa-envelope" />
            Email
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default BlankTrainingForms;
